export const unitConfig = {
    headings: [
        {
            headingLabel: "Inactive",
            icon: "",
            width: "15%",
            inputType: "checkbox",
        },
        {
            headingLabel: "Name",
            icon: "",
            width: "40%",
            inputType: "text",
        }
    ],
    dataNodes: [
        "is_active",
        "lookup_value",
    ],
    inlineEdits: [
        {
            dataNode: "is_active",
            width: "13%"
        },
        {
            dataNode: "lookup_value",
            width: "40%",
        },

    ],
    primaryKey: "lookup_data_id",
    actions: ["pen", "times"],
    nodeFields: [
        {
            column: "is_active",
            icon: "check",
        },
    ],
    buttonFields: [
        {
            column: "",
            icon: "pen",
        },
    ],
    showActionsItemBottom: [
        {
            dataNode: "is_active",
            width: "13",
        },
        {
            dataNode: "lookup_value",
            width: "50%",
        },
    ],
    isUnitAdmin: true,
    isClearFields: true
};